import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import { GET_BOSS_RANKINGS, SHOW_BOSS_RANKINGS_SPINNER } from '../actions/getBossRankings';
import { TAction } from '../actions/types/action';
import { TBossRankingsClientState } from '../libs/store';

export default function bossRankings(
  state: Partial<TBossRankingsClientState> = {},
  action: TAction<any>
): Partial<TBossRankingsClientState> {
  switch (action.type) {
    case GET_BOSS_RANKINGS: {
      return {
        ...state,
        ...action.payload
      };
    }
    case SHOW_BOSS_RANKINGS_SPINNER: {
      return {
        ...state,
        uiLoading: action.payload
      };
    }
    case LOCATION_CHANGE: {
      return state;
    }
    default:
      return state;
  }
}
